import { render, staticRenderFns } from "./Attachment_file.vue?vue&type=template&id=8e5223e8"
import script from "./Attachment_file.vue?vue&type=script&lang=js"
export * from "./Attachment_file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports